import {observable, computed, action, observe} from 'mobx';

import {generateResponseID} from './../utils/Utils';
import ElementStore from './ElementStore';
import L from "leaflet";

export default class AppStore {
    constructor() {
        this.elementStore = new ElementStore(this);

        // Auto close drawer on IconButton press when using mobile
        observe(this.pendingState, (change) => {
            if (change.newValue !== null && this.isMobile) {
                this.drawer.open = false;
            }
        });

        if (window.location.hash.indexOf("response_id") > -1) {
            this.responseID = window.location.hash.split('response_id=')[1]
        } else {
            this.responseID = generateResponseID();
        }
    }

    @action loadConfig(json) {
        this.appConfig = json.config;
        this.environment = json.environment;
        this.branchDisplayName = json.branchDisplayName;
        this.branchId = json.branchId;
        this.meta = json.meta;

        if (Object.keys(this.appConfig.map.baseLayers).length > 1) {
            this.mapState.mode = Object.keys(this.appConfig.map.baseLayers).filter((layer) => this.appConfig.map.baseLayers[layer].isdefault)[0]; //set mode to default layer
            if (!this.mapState.mode) {
                this.mapState.mode = Object.keys(this.appConfig.map.baseLayers)[0];
            }
        } else {
            this.mapState.mode = Object.keys(this.appConfig.map.baseLayers)[0];
        }

        if (this.appConfig.map.zoomLocations && this.appConfig.map.zoomLocations.length > 0){
            this.appConfig.map.zoomLocations.unshift(
                {
                    "defaultName": (json.config.map.defaultName ? json.config.map.defaultName : "Default"),
                    "viewport": {
                        "zoom": json.config.map.viewport.zoom,
                        "center": {
                            "lat": json.config.map.viewport.center.lat,
                            "lng": json.config.map.viewport.center.lng
                        }
                    }
                }
            )
        }
    }

    getMapZooms() {
        return {minZoom: this.appConfig.map.zoom.min, maxZoom: this.appConfig.map.zoom.max};
    }

    getReactionContainerStatus() {
        return this.appConfig.custom.reactionContainer;
    }

    environment = null;
    branchDisplayName = null;
    responseID = null;
    branchId = null;
    meta = null;

    @observable appConfig = {
        map: {
            defaultName: "",
            viewport: {
                center: {
                    lat: 42,
                    lng: -71
                },
                zoom: 13
            },
            baseLayers: {
                "roadmap": {
                    "url": "",
                    "static": "",
                    "title": "Roadmap",
                    "isdefault": false,
                    "enabled": false
                },
                "satellite": {
                    "url": "",
                    "static": "",
                    "accesstoken": "",
                    "title": "Satellite",
                    "isdefault": true,
                    "enabled": true
                },
                "custom": {
                    "url": "",
                    "static": "",
                    "title": "",
                    "isdefault": false,
                    "enabled": false
                }
            },
            overlays: [
                {
                    "name": "Buildings-1",
                    "url": "http://tiles.sasaki.com/georgia-southern/v3.2/main-campus/{z}/{x}/{y}.png"
                },
                {
                    "name": "Buildings-2",
                    "url": "http://tiles.sasaki.com/georgia-southern/v3.1/armstrong/{z}/{x}/{y}.png"
                },
                {
                    "name": "Buildings-3",
                    "url": "http://tiles.sasaki.com/georgia-southern/v3.3/liberty/{z}/{x}/{y}.png"
                }
            ],
            zoomLocations: []
        },
        questions: {
            marker: [{
                questionid: 1,
                text: "",
                icons: [{
                    id: "",
                    text: "",
                    image: ""
                }]
            }],
            polyline: [{
                questionid: 1,
                text: "",
                icons: [{
                    id: "",
                    text: "",
                    image: ""
                }]
            }],
            polygon: [{
                questionid: 1,
                text: "",
                icons: [{
                    id: "",
                    text: "",
                    image: ""
                }]
            }]
        },
        content: {
            brand: {
                logo: "logo.png",
                brandColor: {
                    r: 10,
                    g: 10,
                    b: 10,
                    a: 1
                }
            },
            introduction: {
                headline: "",
                text: "",
                dataUsage: "",
                instructions: ""
            },
            thankyou: {
                headline: "",
                text: "",
                label: "",
                link: ""
            },
            demographics: {
                headline: "",
                description: ""
            }
        },
        survey: {
            schema: {},
            UIschema: {}
        }
    };

    @observable mapState = {
        mode: 'roadmap',
        element: null,
        editLayer: null
    };

    @observable pendingState = {
        element: null,
        popup: false,
        editing: false,
        savePopup: false,
        confirmationPopup: false,
    };

    @observable drawer = {
        active: 'marker',
        open: true,
        expanded: false,
        disabled: false
    };

    @observable isMBIconClicked = false;

    @action toggleMBIconClick() {
        this.isMBIconClicked = !this.isMBIconClicked;
    }

    @observable addMoreButtons = false;

    @action setMoreButtons(setVal) {
        console.log('here..');
        this.addMoreButtons = setVal;
    }

    @action buildSurveySchema = () => {
        let surveyJSON = {
            "schema": {
                "type": "object",
                "properties": {}
            },
            "UISchema": {}
        };

        this.appConfig.survey.forEach(function (e, i) {
            let answers = [];

            e.answers.map(function (answer) {
                answers.push(answer.text);
            });

            if (e.type === "checkboxes") {
                surveyJSON.schema.properties[i] = {
                    "type": "array",
                    "title": e.text,
                    "items": {
                        "type": "string",
                        "enum": answers
                    },
                    "uniqueItems": true
                };
            } else if (e.type === "textfield" || e.type === "textarea") {
                surveyJSON.schema.properties[i] = {
                    "type": "string",
                    "title": e.text
                };
            } else {
                surveyJSON.schema.properties[i] = {
                    "type": "string",
                    "title": e.text,
                    "enum": answers
                };
            }

            if (e.type !== "dropdown" && e.type !== "textfield") {
                surveyJSON.UISchema[i] = {
                    "ui:widget": e.type
                }
            }
        });

        //console.log("surveyJSON: " + JSON.stringify(surveyJSON));
        return surveyJSON;
    };

    @observable isMobile = false;
    @observable introModal = true;

    @action setSavePopup(val) {
        this.pendingState.savePopup = val;
    }

    @action setConfirmationPopup(val) {
        this.pendingState.confirmationPopup = val;
    }

    @action setIntroModal(val) {
        this.introModal = val;
    }

    @action setPendingElementPosition(val) {
        this.pendingState.element.position = val;
    }

    @action setPendingElementReaction(val) {
        this.pendingState.element.reaction = val;
    }

    @action setPendingElementStarRating(val) {
        this.pendingState.element.starRating = val;
    }

    @action setPendingElementText(val) {
        this.pendingState.element.text = val;
    }

    @action setPendingStateEditing(val) {
        this.pendingState.editing = val;
    }

    @action setMapViewport(val) {
        this.appConfig.map.viewport = val;
    }

    @action toggleMapMode() {
        this.mapState.mode = Object.keys(this.appConfig.map.baseLayers).filter((key) => (key !== this.mapState.mode) && this.appConfig.map.baseLayers[key].enabled)[0]
    }

    @computed get inactiveMapMode() {
        return Object.keys(this.appConfig.map.baseLayers).filter((key) => (key !== this.mapState.mode) && this.appConfig.map.baseLayers[key].enabled)[0];
    }

    @action setIsMobile(val) {
        this.isMobile = val;
    }

    @action setDrawer(drawer) {
        Object.keys(drawer).forEach((k) => {
            this.drawer[k] = drawer[k];
        });
    }

    @action disableDrawer(val) {
        this.drawer.disabled = val;
    }

    @computed get editMode() {
        return (this.pendingState.element !== null);
    }

    @computed get placingIconMode() {
        return this.editMode && !this.pendingState.savePopup;
    }

    @computed get allowSave() {
        if (this.pendingState.element) {
            if (this.pendingState.element.icon.type === "icon") {
                return !!this.pendingState.element.position;
            } else if (this.pendingState.element.icon.type === "polyline") {
                return !!this.pendingState.element.position[1];
            } else if (this.pendingState.element.icon.type === "polygon") {
                return !!this.pendingState.element.position[2];
            }
        } else {
            return false;
        }
    }

    @action configureElement(element) {
        this.mapState.element = element;
        if (this.mapState.element) {
            this.mapState.element.options.closePopupOnClick = false;
            this.mapState.element.options.viewport = this.appConfig.map.viewport;//CODE-REVIEW:RAJ:we shouldn't be setting for elements inidividually here, can this be centralized?
            this.mapState.editLayer = new L.LayerGroup();
            this.mapState.element.editTools.editLayer = this.mapState.editLayer;
            this.mapState.editLayer.addTo(this.mapState.element);
        }
    }

    @action clearPending = () => {
        this.pendingState.popup = false;
        this.pendingState.element = null;
        this.pendingState.editing = false;
        this.pendingState.savePopup = false;
        this.pendingState.confirmationPopup = false;
        this.drawer.disabled = false;
    };

    @action returnLayerImage(url) {
        let layerURL = url;
        layerURL = layerURL.replace("{z}", `${this.appConfig.map.viewport.center.lng}`);
        layerURL = layerURL.replace("{x}", `${this.appConfig.map.viewport.center.lat}`);
        layerURL = layerURL.replace("{y}", `${this.appConfig.map.viewport.zoom}`);

        return layerURL;
    };
}



// WEBPACK FOOTER //
// ./src/stores/AppStore.js